import { getCompanySelectedLanguage } from './Experiments';
import RequestLib from './Request';
import { getUserAgent } from './Utils';

export const startChat = (message, phone) => {
  const params = [];
  if (phone) {
    params.push(`phone=${(phone || '').replace(/\+/g, '').replace(/\s/g, '')}`);
  }
  message = encodeURIComponent(message);
  if (message) {
    params.push(`text=${message}`);
  }
  const language = getCompanySelectedLanguage();
  if (language) {
    params.push(`lang=${language}`);
  }
  const paramString = params.join('&');
  if (/Android|iPhone|iPod|webOS|BlackBerry|Windows Phone/i.test(getUserAgent())) {
    window.location.href = 'https://api.whatsapp.com/send?' + paramString;
  } else {
    window.open('https://api.whatsapp.com/send?' + paramString);
  }
};

export const openWhatsAppWebForChat = ({ whatsappNumber, text }) => {
  window.location.href = `https://wa.me/${(whatsappNumber || '')
    .replace(/\+/g, '')
    .replace(/\s/g, '')}?text=${text}`;
};

export const getWhatsAppLoginNumber = () =>
  RequestLib({
    method: 'GET',
    url: '/api/whatsapp/login-number'
  })
    .then(({ whatsappNumber } = {}) => {
      if (!whatsappNumber) {
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject('Missing number');
      }
      return whatsappNumber;
    })
    .catch((err) => Promise.reject(err));

export const verifyWhatsAppLoginCode = (code) =>
  RequestLib({
    method: 'POST',
    url: '/api/whatsapp/verify-login',
    params: { code }
  })
    .then(({ status, token } = {}) => {
      if (status !== 'SUCCESS') {
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject('Token expired');
      }
      return { token };
    })
    .catch((err) => Promise.reject(err));
